export const T = {
  navy: "#0A1B3D",
  navyDeep: "#06122B",
  navyMid: "#13284E",
  navySoft: "#1B3463",

  gold: "#E0B056",
  goldGlow: "#F5C76A",
  goldDeep: "#9C7022",

  cream: "#F7F1E1",
  creamWarm: "#EFE6CC",
  ink: "#1A1A2E",
  inkSoft: "#5C5743",
  mist: "rgba(247,241,225,0.62)",
  mistFaint: "rgba(247,241,225,0.32)",
  hairline: "rgba(247,241,225,0.08)",

  serif: '"Frank Ruhl Libre", "David Libre", Georgia, serif',
  sans: '"Heebo", -apple-system, system-ui, sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, monospace',

  r1: 8,
  r2: 14,
  r3: 22,
  r4: 32,

  shadowSoft: "0 4px 16px rgba(6,18,43,0.18)",
  shadowMed: "0 12px 36px rgba(6,18,43,0.32)",
  shadowGold: "0 8px 24px rgba(224,176,86,0.35)",

  ease: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.16, 1, 0.3, 1)",
} as const;

export type Tokens = typeof T;
